import createRoute from '@widesk-ui/tools/createRoute';
import EventModel  from '@models/audit/EventModel';

export default createRoute.table('/events', 'audit', 'EventTable', EventModel.localize('plural'));